import { z } from "zod/v4";
export const checklistIdSchema = z.object({ id: z.uuid() });
export const checklistMaterialInputSchema = z.object({
    id: z.uuid().optional(),
    label: z.string().trim().min(1, "Le libellé est obligatoire.").max(300),
    catalogProductId: z.uuid().nullable().default(null),
});
export const checklistSaveInputSchema = z
    .object({
    id: z.uuid().nullable(),
    expectedRevision: z.number().int().nonnegative(),
    name: z.string().trim().min(1, "Le nom est obligatoire.").max(150),
    materialIds: z.array(z.uuid()).max(500),
})
    .refine((input) => new Set(input.materialIds).size === input.materialIds.length, {
    message: "Un matériel ne peut figurer qu’une fois dans une checklist.",
    path: ["materialIds"],
});
export function checklistContentKey(checklist) {
    return JSON.stringify(checklist.items.map((item) => [
        item.id,
        item.label,
        item.catalogProductId,
        item.catalogReference,
    ]));
}
export const checklistProgressSchema = z.object({
    contentKey: z.string(),
    checkedIds: z.array(z.uuid()),
});
export function readChecklistProgress(value, checklist) {
    const empty = { contentKey: checklistContentKey(checklist), checkedIds: [] };
    if (!value)
        return { progress: empty, needsRestart: false };
    try {
        const parsed = checklistProgressSchema.safeParse(JSON.parse(value));
        if (!parsed.success)
            return { progress: empty, needsRestart: false };
        if (parsed.data.contentKey !== empty.contentKey) {
            return { progress: empty, needsRestart: true };
        }
        const validIds = new Set(checklist.items.map((item) => item.id));
        return {
            progress: {
                ...parsed.data,
                checkedIds: [...new Set(parsed.data.checkedIds)].filter((id) => validIds.has(id)),
            },
            needsRestart: false,
        };
    }
    catch {
        return { progress: empty, needsRestart: false };
    }
}
//# sourceMappingURL=Checklists.js.map